(function(){
    'use strict';
    
    // document.addEventListener("DOMContentLoaded", function(){
    //     // Resize Subtext elements to the width of its H2 (Previous sibling)
    //     const resizeDivs = document.querySelectorAll('.jcu-v1__js-resize');
    //     if (resizeDivs.length >= 1){
            
    //         window.addEventListener("resize", bannerSetSubtextWidths);
            
    //         function bannerSetSubtextWidths(){    
                
    //             for(var i=0;i<resizeDivs.length;i++){
                    
    //                 resizeDivs[i].style.width = resizeDivs[i].previousElementSibling.clientWidth + "px";
    //             }
    //         }
        
    //         bannerSetSubtextWidths(resizeDivs);
    //     }
    
    // });
    
}());
